export const appConfig = {
    backendUrl: 'https://qa2.srw.aisnovations.com',
    redirectOnError: false,
};
